import { jsx } from 'react/jsx-runtime';
import React__default, { useState, useLayoutEffect } from 'react';
import { lightTheme, darkTheme } from '../utils/themes.js';

var Theme;
(function (Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})(Theme || (Theme = {}));
const themes = {
    [Theme.Light]: lightTheme,
    [Theme.Dark]: darkTheme,
};
const ThemeContext = React__default.createContext({
    theme: Theme.Light,
});
/**
 * @
 * @param theme overrides the `setTheme` result
 * @returns
 */
const ThemeProvider = ({ children, theme, }) => {
    const [internalTheme, setInternalTheme] = useState(Theme.Light);
    const providedTheme = theme ?? internalTheme;
    useLayoutEffect(() => {
        const themeObject = themes[providedTheme];
        Object.entries(themeObject).forEach(([key, value]) => {
            document.documentElement.style.setProperty(`--${key}`, value);
        });
    }, [providedTheme]);
    return (jsx(ThemeContext.Provider, { value: { theme: providedTheme, setTheme: setInternalTheme }, children: children }));
};

export { Theme, ThemeContext, ThemeProvider };
//# sourceMappingURL=ThemeProvider.js.map
